
import React, { useState } from "react";
import {  mdiCloseCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'

class PageNotRole extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
        };
    }

    render() {
        return (
            <div class="text-center" style={{ color: "red", paddingTop: "100px", fontWeight: "bold" }}>
            <Icon path={mdiCloseCircleOutline} title="User Profile" color="red" size={3} />
            <h3>BẠN KHÔNG CÓ QUYỀN VÀO CHỨC NĂNG NÀY</h3>
            <h5>Vui lòng liên hệ với người quản trị hệ thống hoặc chủ cửa hàng để được cấp quyền</h5>
        </div>
        );
    }
}

export default PageNotRole;